import { createRouter, createWebHistory } from 'vue-router'
import AuthView from '../views/AuthView.vue'
import StoryView from '../views/StoryView.vue'
import MemoryView from '../views/MemoryView.vue'
import TogetherView from '../views/TogetherView.vue'
import ProfileView from '../views/ProfileView.vue'
import { getAuthToken } from '../utils/auth'

const routes = [
  { path: '/', name: 'auth', component: AuthView, meta: { title: '登录入口', guestOnly: true } },
  { path: '/stories', name: 'stories', component: StoryView, meta: { title: '故事记录', requiresAuth: true } },
  { path: '/memory-book', name: 'memory-book', component: MemoryView, meta: { title: '足迹册', requiresAuth: true } },
  { path: '/together', name: 'together', component: TogetherView, meta: { title: '共同生活', requiresAuth: true } },
  { path: '/profile', name: 'profile', component: ProfileView, meta: { title: '个人中心', requiresAuth: true } }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  }
})

router.beforeEach((to) => {
  const token = getAuthToken()

  if (to.meta.requiresAuth && !token) {
    return { path: '/', query: { redirect: to.fullPath } }
  }

  if (to.meta.guestOnly && token) {
    return { path: '/stories' }
  }

  return true
})

export default router
